import { render, staticRenderFns } from "./CatalogTrainingList.vue?vue&type=template&id=3420eda2&scoped=true"
import script from "./CatalogTrainingList.vue?vue&type=script&lang=js"
export * from "./CatalogTrainingList.vue?vue&type=script&lang=js"
import style0 from "./CatalogTrainingList.vue?vue&type=style&index=0&id=3420eda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3420eda2",
  null
  
)

export default component.exports